// PHP casts request values to strings before joining key=value pairs for SIGN.
// In particular, arrays become "Array" and false/null become an empty string.
export function serializeSignParams(params) {
  return Object.keys(params || {})
    .filter(key => params[key] !== undefined)
    .sort()
    .map(key => {
      const value = params[key]
      let text
      if (value === null || value === false) text = ''
      else if (value === true) text = '1'
      else if (typeof value === 'object') text = 'Array'
      else text = String(value)
      return `${key}=${text}`
    })
    .join('&')
}
